import React from "react";
import urekwereAugustina from "../../assets/staff/CollegeofNursing/urekwere_Augustina.jpg";
import saliuAdenike from "../../assets/staff/CollegeofNursing/saliu_Adenike.jpg";
import dadaAdejumoke from "../../assets/staff/CollegeofNursing/dada_Adejumoke.jpg";
import kolawoleOluwabusola from "../../assets/staff/MedicalandPsychiatrysocialwork/angela_edozie-ogili.jpeg";
import ogunniranElizabeth from "../../assets/staff/MedicalandPsychiatrysocialwork/hilda_sasere.jpeg";
import OnuhChetachi from "../../assets/staff/MedicalandPsychiatrysocialwork/mariam_liasu.jpeg";
import oloruntobaOlusola from "../../assets/staff/Default/female.jpg";
import ajayiAdejoke from "../../assets/staff/MedicalandPsychiatrysocialwork/rhoda_farinde.jpeg";
import danielKayode from "../../assets/staff/MedicalandPsychiatrysocialwork/olalekan_olasode.jpg";
import hamzatOluwatoyin from "../../assets/staff/MedicalandPsychiatrysocialwork/ijeoma_oguama-amaje.jpeg";


const CollegeofNursing = [
{
    name: "UREKWERE AUGUSTINA NKECHINYERE",
    qualification:"RN-1997,RM-2000,RNE-2006,BNSC-2010,MNSC-2023",
    designation: "DIRECTOR NURSING EDUCATION ",
    photo: "urekwereAugustina",
  },
  {
    name: "SALIU ADENIKE AMINAT",
    qualification:"RN-1998,RM-2001,RNT-2012,BSC EDU-2012,BNSC-2014,MNSC-2020",
    designation: "DEPUTY DIRECTOR NURSING EDUCATION",
    photo: "saliuAdenike",
  },
   {
    name: "DADA ADEJUMOKE ADEDOJA",
    qualification:"RN-1993,RM-1995,RNE-2000,RAEN-2002,BNSC-2000,MSCN-2011",
    designation: "ASSISTANT DIRECTOR NURSING EDUCATION",
    photo: "dadaAdejumoke",
  },
   {
    name: "KOLAWOLE OLUWABUSOLA MONISOLA",
    qualification:"RN-2003,RM-2005,RNE-2016,BNSC-2018,MSC- 2022",
    designation: "ASSISTANT DIRECTOR NURSING EDUCATION",
    photo: "kolawoleOluwabusola",
  },
   {
    name: "OGUNNIRAN ELIZABETH OYINLOLA",
    qualification:"RN-2003,RM-2005,BNSC-2022",
    designation: "ASSISTANT DIRECTOR NURSING OFFICER ",
    photo: "ogunniranElizabeth",
  },
{
    name: "ONUH CHETACHI FAVOUR",
    qualification:"RN-1997,RM-1999,RNE-2015,BNSC-2005,MSCN-2021",
    designation: "CHIEF NURSE EDUCATOR",
    photo: "OnuhChetachi",
  },
  {
    name: "OLORUNTOBA OLUSOLA COMFORT",
    qualification:"RN-2007,RM-2010,RNT-2016,BNSC-2020",
    designation: "CHIEF NURSE EDUCATOR",
    photo: "oloruntobaOlusola",
  },
  {
    name: "AJAYI ADEJOKE MOROLADE",
    qualification:"RN-1994,RPHN-2015,BNSC-2014,PGDE-2019",
    designation: "ASSISTANT CHIEF NURSE EDUCATOR ",
    photo: "ajayiAdejoke",
  }, 
{
    name: "DANIEL KAYODE VICTOR",
    qualification:"RN-2007,DNE-2017,BNSC-2017,RNE—2018",
    designation: "ASSISTANT CHIEF NURSE EDUCATOR ",
    photo: "danielKayode",
  }, 
  {
    name: "HAMZAT OLUWATOYIN OLAMIDE",
    qualification:"RN-2009,RM-2015,BNSC-2015,MNSC-2023",
    designation: "SENIOR NURSE EDUCATOR",
    photo: "hamzatOluwatoyin",
  }, 
   {
    name: "OPARA JULIANA NKECHI",
    qualification:"RN-2010,BNSC-2011",
    designation: "SENIOR NURSE EDUCATOR",
    photo: "oparaJuliana",
  }, 
  {
    name: "OYEWUMI ADESOLA O.",
    qualification:"RN-2016,RM-2018,BNSC-2017",
    designation: "SENIOR NURSE TUTOR",
    photo: "oyewumiAdesola",
  },
  {
    name: "ONYEDIBE JOSEPHINE NKEM",
    qualification:"",
    designation: "SENIOR NURSE EDUCATOR",
    photo: "onyedibeJosephine",
  },
   {
    name: "OLISE OLUWANIKE GRACE",
    qualification:"BNSc, RM, RN",
    designation: "SENIOR NURSE TUTOR",
    photo: "oliseOluwanike",
  },
   {
    name: "KAIFE ADETAYO OLUWADUNNI",
    qualification:"RN,RM, BNSC",
    designation: "NURSE TUTOR",
    photo: "kaifeAdetayo",
  },
   {
    name: "AHMED SIMILOLUWA DEBORAH",
    qualification:"BSC-2012,MSC-2015",
    designation: "SENIOR SCIENTIFIC OFFICER",
    photo: "ahmedSimiloluwa",
  },
{
    name: "KUSIMO OLUBUKOLA MOYOSOLA",
    qualification:"RN-2007,RM-2006,BNSC-2012",
    designation: "CHIEF NURSING OFFICER",
    photo: "kusimoOlubukola",
  },
  {
    name: "ADEMUYIWA MONISOLA TOMISIN",
    qualification:"RN-2007,RM-2014,RPHN-2015,BNSC-2014",
    designation: "ASSISTANT CHIEF NURSING OFFICER",
    photo: "ademuyiwaMonisola",
  },
  {
    name: "OJOWURO TAIWO OLATEJU",
    qualification:"HND-Secretarial Studies-1997,Diploma in Computer-2002",
    designation: "CHIEF CONFIDENTIAL SECRETARY",
    photo: "ojowuroTaiwo",
  }, 
{
    name: "ODUKOGE GRACE OLAWUNMI ",
    qualification:"OND-Public Administration-2008,WASSCE-2004",
    designation: "PRINCIPAL EXECUTIVE OFFICER II",
    photo: "odukogeGrace",
  }, 
  {
    name: "GIWA OLUWASESAN OMONIYI",
    qualification:"OND- Business Administration,Certification-Ophthalmic Technician",
    designation: "SENIOR EXECUTIVE OFFICER II",
    photo: "giwaOluwasesan",
  }, 
   {
    name: "ALAYANDE SAHEED NIYI",
    qualification:"HND-Computer Science-2011",
    designation: "HIGHER DATA PROCESSING OFFICER",
    photo: "alayandeSaheed",
  }, 
    {
    name: "ADELODUN ABDULLATEEF FUNSHO",
    qualification:"BSC-Library and Information Science",
    designation: "LIBRARIAN II",
    photo: "adelodunAbdullateef",
  },
   {
    name: "OKPEKI MARY OLOLADE",
    qualification:"BSC- Library and Information Science",
    designation: "LIBRARIAN II",
    photo: "okpekiMary",
  },
   {
    name: "KESHINRO-OBALOWU AZEEZAT ALAYO",
    qualification:"SSCE2008&2010,Diploma in computer-2011",
    designation: "CHIEF DATA PROCESSING ASSISTANT",
    photo: "keshinroAzeezat",
  },
   {
    name: "AYEKULEHIN OLURANTI AGUNBIADE",
    qualification:"WAEC,DIP. Desktop Publishing",
    designation: "ASSISTANT DATA PROCESSING ",
    photo: "",
  },
{
    name: "SANNI SAHEED ALABI",
    qualification:"WAEC-1995",
    designation: "HEAD PORTER",
    photo: "sanniSaheed",
  },
  {
    name: "OLORUNSE SIMBIAT SEWA",
    qualification:"ADMINISTRATIVE OFFICER",
    designation: "CLERICAL OFFICER",
    photo: "",
  },
   {
    name: "PHILLIPS AFOLAKE SEUN",
    qualification:"WAEC",
    designation: "LOCUM PORTER",
    photo: "philipsAfolake",
  },
{
    name: "ADELEKE TITILAYO TAIBAT",
    qualification:"WAEC",
    designation: "LOCUM PORTER",
    photo: "adelekeTitilayo",
  },
  {
    name: "ADELUSI BOLUWATIFE ABIKE",
    qualification:"WAEC",
    designation: "HEALTH ASSISTANT",
    photo: "adelusiBolu",
  },
  {
    name: "BADIRU SAMUEL OLUWATOBI",
    qualification:"NECO",
    designation: "HEALTH ASSISTANT",
    photo: "badiruSamuel",
  },
  
]

export default CollegeofNursing;